<template>
  <div>
    <!-- Hero -->
    <div class="position-relative">
      <section class="section-shaped my-0">
        <div class="shape shape-skew" style="background-color: #0066CC">
          <span></span><span></span><span></span><span></span>
          <span></span><span></span><span></span><span></span><span></span>
        </div>
        <div class="container shape-container d-flex">
          <div class="col px-0">
            <div class="row">
              <div class="col-lg-8">
                <h1 class="display-3 text-white">{{ post.title }}</h1>
                <div class="text-white-50 mb-3">
                  <span v-if="post.author">
                    <i class="fa fa-user mr-1"></i>{{ post.author }}
                  </span>
                  <span v-if="post.date" class="ml-3">
                    <i class="fa fa-calendar mr-1"></i>{{ formatDate(post.date) }}
                  </span>
                </div>
                <div v-if="post.tags && post.tags.length">
                  <span
                    v-for="(tag, idx) in post.tags"
                    :key="idx"
                    class="badge badge-pill badge-white mr-1"
                    style="font-size: 0.75rem;"
                  >
                    {{ tag }}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>

    <!-- Content -->
    <section class="section section-lg pt-5">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-lg-8">
            <!-- Cover Image -->
            <div v-if="post.coverImage" class="mb-5">
              <img :src="post.coverImage" class="img-fluid rounded shadow" :alt="post.title" />
            </div>

            <!-- Post Content -->
            <div class="blog-content" v-html="post.content"></div>

            <!-- Back Link -->
            <div class="mt-5 pt-4 border-top">
              <router-link to="/blog" class="btn btn-outline-primary">
                <i class="fa fa-arrow-left mr-2"></i>Back to Blog
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'BlogPostView',
  created() {
    this.$store.dispatch('blog/fetchPosts')
  },
  computed: {
    post() {
      const id = this.$route.params.id
      return this.$store.getters['blog/getPostById'](id) || {
        title: 'Post Not Found',
        content: '<p>Sorry, this blog post could not be found.</p>',
        tags: [],
        author: '',
        date: ''
      }
    }
  },
  methods: {
    formatDate(dateStr) {
      if (!dateStr) return ''
      const options = { year: 'numeric', month: 'long', day: 'numeric' }
      return new Date(dateStr).toLocaleDateString('en-US', options)
    }
  }
}
</script>

<style scoped>
.blog-content {
  font-size: 1.1rem;
  line-height: 1.9;
  color: #333;
}

.blog-content >>> h2 {
  margin-top: 2rem;
  margin-bottom: 1rem;
  font-weight: 600;
}

.blog-content >>> p {
  margin-bottom: 1.25rem;
}

.blog-content >>> blockquote {
  border-left: 4px solid #5e72e4;
  padding: 0.75rem 1.25rem;
  margin: 1.5rem 0;
  color: #525f7f;
  font-style: italic;
  background: #f8f9fe;
  border-radius: 0 0.375rem 0.375rem 0;
}

.blog-content >>> ul,
.blog-content >>> ol {
  padding-left: 1.5rem;
  margin-bottom: 1.25rem;
}

.blog-content >>> li {
  margin-bottom: 0.5rem;
}

.blog-content >>> img {
  max-width: 100%;
  border-radius: 0.375rem;
  margin: 1.5rem 0;
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);
}

.blog-content >>> a {
  color: #5e72e4;
  text-decoration: underline;
}

.badge-white {
  background-color: rgba(255, 255, 255, 0.9);
  color: #333;
}
</style>
